import { render, staticRenderFns } from "./EmployeeNewView.vue?vue&type=template&id=1925719a&scoped=true&"
import script from "./EmployeeNewView.vue?vue&type=script&lang=js&"
export * from "./EmployeeNewView.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeNewView.vue?vue&type=style&index=0&id=1925719a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925719a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
